{
  "title": "Grupos",
  "subtitle": "Reflejados desde el directorio del cliente. Define rellenos para atributos vacíos, una prioridad si alguien está en más de un grupo, y una firma opcional para miembros sin regla de operador.",
  "searchPlaceholder": "Buscar grupos",
  "colGroup": "Grupo",
  "colMembers": "Miembros",
  "colPriority": "Prioridad",
  "colOverrides": "Anulaciones",
  "colSignature": "Firma",
  "emptySearch": "Ningún grupo coincide con esa búsqueda.",
  "emptyNone": "Aún no se han sincronizado grupos. Conecta un directorio en Resumen o Incorporación.",
  "priority": "Prioridad",
  "signatureTemplate": "Firma del grupo",
  "noSignature": "Ninguna (continuar)",
  "overrides": "Anulaciones de atributos",
  "save": "Guardar grupo",
  "saved": "Grupo guardado.",
  "saveError": "No se pudo guardar ese grupo.",
  "none": "Ninguna",
  "count": "{{count}}",
  "groupFallback": "Grupo",
  "fieldsCount": "{{count}} campo",
  "fieldsCount_other": "{{count}} campos",
  "signatureSet": "Definida",
  "overridePriorityTitle": "Prioridad de anulación",
  "overridePriorityHint": "Cuando una persona está en varios grupos que rellenan el mismo campo vacío, gana la prioridad más alta.",
  "savePriority": "Guardar prioridad",
  "prioritySaved": "Prioridad guardada.",
  "groupSignatureTitle": "Firma del grupo",
  "groupSignatureHint": "Se usa cuando ninguna regla de operador coincide y la persona no tiene firma personalizada. Pierde frente a Reglas; gana al predeterminado del inquilino.",
  "publishTemplateFirst": "Publica una plantilla antes de asignar una firma de grupo.",
  "newMessages": "Mensajes nuevos",
  "replies": "Respuestas",
  "sameAsNew": "Igual que nuevo",
  "saveSignature": "Guardar firma",
  "signatureSaved": "Firma del grupo guardada.",
  "signatureCleared": "Firma del grupo borrada.",
  "fieldFillsTitle": "Rellenos de campos",
  "fieldFillsSaved": "Rellenos de campos guardados.",
  "membersTitle": "Miembros",
  "membersHint": "La pertenencia se sincroniza desde el directorio, incluidos los grupos anidados.",
  "noMembers": "Aún no hay miembros sincronizados.",
  "viaNestedGroup": "vía grupo anidado",
  "couldNotSave": "No se pudo guardar."
}
